exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.svg-piece {\n  width: 12.5%;\n  height: 12.5%;\n  font-weight: bold;\n  font-size: 16px;\n  text-shadow: 0 2px 2px white;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  pointer-events: none;\n  touch-events: none;\n  z-index: 2;\n  stroke-width: 6px;\n  transition: transform 0.1s;\n}\n.white {\n  color: white;\n  stroke: black;\n}\n", ""]);

// exports
